import { defineStore } from "pinia";

import type { NameId } from "@/models/clients";
import type { CallLog, CallOutPayload } from "@/models/communicationLogs";

export interface ActiveCallSession extends Partial<CallLog>, CallOutPayload {
  client_name: NameId | undefined;
  partner: string | undefined;
}

interface UseCallsState {
  callDialog: CallLog | null;
  activeCallSession: ActiveCallSession | null;
}

const getDefaultState = (): UseCallsState => ({
  callDialog: null,
  activeCallSession: null,
});

const useCallsStore = defineStore("calls", {
  state: getDefaultState,
});

export default useCallsStore;
